import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const ArrowDropUpIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}>
      <path d="M8.2 14C8.05 14 7.92916 13.95 7.8375 13.85C7.74583 13.75 7.7 13.6333 7.7 13.5C7.7 13.4667 7.75 13.35 7.85 13.15L11.475 9.525C11.5583 9.44167 11.6417 9.38334 11.725 9.35C11.8083 9.31667 11.9 9.3 12 9.3C12.1 9.3 12.1917 9.31667 12.275 9.35C12.3583 9.38334 12.4417 9.44167 12.525 9.525L16.15 13.15C16.2 13.2 16.2375 13.2542 16.2625 13.3125C16.2875 13.3708 16.3 13.4333 16.3 13.5C16.3 13.6333 16.2542 13.75 16.1625 13.85C16.0708 13.95 15.95 14 15.8 14H8.2Z" fill={color}/>
    </svg>
  );
};

export default ArrowDropUpIcon;
